



























import Vue from "vue";
import { PropType } from "vue";
import { KEYCODE } from "@/constants/event";

import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";

import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Overlay,
    FloatingView,
    Button,
    ButtonConfig,
    Heading,
    Caption
  },
  props: {
    selectedEvent: {
      type: Object as PropType<Props["selectedEvent"]>,
      required: true
    }
  },
  data() {
    return {
      title: this.selectedEvent.name
    };
  },
  mounted() {
    const $cancelButton = (this.$refs.cancelButton as Vue).$el as HTMLElement;
    $cancelButton.focus();
    window.addEventListener("keyup", this.handlePressEsc);
  },
  methods: {
    handleClickCancel() {
      this.$emit("clickCancel");
    },
    handleClickDelete() {
      this.$emit("clickDelete");
    },
    handlePressEsc(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.handleClickCancel();
    }
  }
});
